.button {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
  border-width: 0.0625rem;
  border-style: solid;
  border-radius: 0.625rem;
  font-size: inherit;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;

  svg {
    pointer-events: none;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      animation: rotate 1.5s linear infinite;
    }
  }

  &[disabled],
  &.loading {
    opacity: 0.7;
  }

  &.round {
    border-radius: 99rem;
  }

  &.rounded {
    border-radius: 1rem;
  }

  &.centered {
    justify-content: center;
  }

  &.inherit {
    &:not(.round, .rounded) {
      border-radius: inherit;
    }
  }

  &.primary {
    &.default {
      border-color: var(--primary-600);
      color: var(--neutral);
      background: var(--primary-gradient-700);
    }

    &.outline {
      border-color: var(--primary-600);
      color: var(--primary-600);
      background: transparent;
    }

    &.ghost {
      border-color: transparent;
      color: var(--primary-700);
      background: transparent;
    }

    &.link {
      border-color: transparent;
      color: var(--primary-700);
      background: transparent;
    }
  }

  &.secondary {
    &.default {
      border-color: var(--neutral);
      color: var(--neutral-600);
      background: var(--neutral);
      box-shadow: 0 0.0625rem 0.375rem -0.125rem
        rgba(var(--neutral-800-rgb), 0.3);

      &:hover {
        border-color: var(--neutral-50);
        background: var(--neutral-50);
      }

      &:active {
        border-color: var(--neutral-200);
        background: var(--neutral-200);
      }
    }

    &.outline {
      border: 0.0625rem solid var(--neutral-200);
      color: var(--neutral-600);
      background: var(--neutral);

      &:hover {
        background: var(--neutral-50);
      }

      &:active {
        background: var(--neutral-200);
      }
    }

    &.ghost {
      border-color: transparent;
      color: var(--neutral-600);
      background: transparent;

      &:hover {
        background: var(--neutral-200);
      }
    }

    &.link {
      border-color: transparent;
      color: var(--neutral-600);
      background: transparent;
    }

    &.clear {
      border: 0.0625rem solid rgba(var(--neutral-rgb), 0.2);
      color: var(--neutral);
      background: rgba(var(--neutral-rgb), 0.12);

      &:hover {
        background: rgba(var(--neutral-rgb), 0.16);
      }

      &:active {
        background: rgba(var(--neutral-rgb), 0.2);
      }
    }
  }

  &.danger {
    &.outline {
      border: 0.0625rem solid var(--neutral-200);
      color: var(--danger);
      background: var(--neutral);

      &:hover {
        background: var(--neutral-50);
      }

      &:active {
        background: var(--neutral-200);
      }
    }
  }

  &.dark {
    &.default {
      border-color: var(--primary-800);
      color: var(--neutral);
      background: var(--primary-800);
    }
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
